import type { ThemeVariantMap } from "@/theme/types";

import { apollocinemaEEDarkTheme } from "./apollocinema.EE.dark";

export const apollocinemaEE: ThemeVariantMap = {
  DARK: apollocinemaEEDarkTheme,
} as const;
